/** 页面信息 */
const page = new (function () {
  this.title = '环境行政处罚案件收藏夹'
  this.icon = 'iconfont iconicon_group'
  this.name = 'penalize_punish_in_favorite'
  /**菜单编号 */
  this.code = 'penalize_punish_in_favorite'
  /**菜单别名 */
  this.aliasName = 'menu'
  /**路由地址 */
  this.path = '/fill/in/punish/favorite'
  //**接口权限 */
  this.permissions = []
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
